

const EventTypes = [
  {
    title: 'Welcome Event',
    value: 'WELCOME_EVENT'
  },
  {
    title: 'Rehearsal Dinner',
    value: 'REHEARSAL_DINNER'
  },
  {
    title: 'Wedding',
    value: 'WEDDING'
  },
  {
    title: 'Ceremony',
    value: 'CEREMONY'
  },
  {
    title: 'Reception',
    value: 'RECEPTION'
  },
  {
    title: 'After Party',
    value: 'AFTER_PARTY'
  },
  {
    title: 'Brunch',
    value: 'BRUNCH'
  },
  {
    title: 'Other',
    value: 'OTHER'
  }
];

export default EventTypes;



/** WEBPACK FOOTER **
 ** ./src/components/manage/events/util/EventTypes.js
 **/